import { Sparkles, Info, User, Rocket, AlertTriangle } from "lucide-react";

export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="about-page">
      <div className="flex items-center gap-3 mb-2">
        <span className="h-10 w-10 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center">
          <Sparkles className="h-5 w-5 text-white" />
        </span>
        <h1 className="text-4xl font-bold tracking-tighter">PsycGenie</h1>
      </div>
      <p className="text-base md:text-lg text-muted-foreground mb-10">
        AI-powered revision for AQA A-Level Psychology.
      </p>

      <div className="space-y-6">
        <section className="rounded-3xl border border-border bg-card p-8" data-testid="about-what-it-is">
          <div className="flex items-center gap-2 mb-3">
            <Info className="h-4 w-4 text-primary" />
            <h2 className="text-lg font-semibold uppercase tracking-wide">What it is</h2>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            PsycGenie is a revision tool for AQA A-Level Psychology (7182). It generates realistic practice papers,
            marks written answers against AQA-style level descriptors, predicts which topics are due to come up, and
            lets you drill individual subtopics with targeted questions — all built around real past papers, mark
            schemes and examiner reports from 2017 to 2025.
          </p>
        </section>

        <section className="rounded-3xl border border-border bg-card p-8" data-testid="about-why-built">
          <div className="flex items-center gap-2 mb-3">
            <Rocket className="h-4 w-4 text-primary" />
            <h2 className="text-lg font-semibold uppercase tracking-wide">Why it was built</h2>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            PsycGenie started as a project to make revising A-Level Psychology more active and less passive. Instead of
            just reading notes, students can sit papers under timed conditions, get instant feedback on where they lost
            marks, and see exactly which subtopics to prioritise. It was built by a psychology student who wanted a
            smarter way to prepare for the exam.
          </p>
        </section>

        <section className="rounded-3xl border border-border bg-card p-8" data-testid="about-who-built">
          <div className="flex items-center gap-2 mb-3">
            <User className="h-4 w-4 text-primary" />
            <h2 className="text-lg font-semibold uppercase tracking-wide">Who built it</h2>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Built by Alec Lyons, an AQA A-Level Psychology student.
          </p>
        </section>

        <section className="rounded-3xl border border-border bg-card p-8" data-testid="about-beta">
          <div className="flex items-center gap-2 mb-3">
            <Sparkles className="h-4 w-4 text-primary" />
            <h2 className="text-lg font-semibold uppercase tracking-wide">Beta</h2>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            PsycGenie is in beta and under active development. Features are still being tested and improved, and new
            topics and tools are being added regularly.
          </p>
        </section>

        <section
          className="rounded-3xl border-2 border-amber-500/50 bg-amber-500/10 p-8"
          data-testid="about-important"
        >
          <div className="flex items-center gap-2 mb-3">
            <AlertTriangle className="h-4 w-4 text-amber-500" />
            <h2 className="text-lg font-semibold uppercase tracking-wide text-amber-500">
              Important — Please read
            </h2>
          </div>
          <p className="text-sm text-foreground/90 leading-relaxed">
            PsycGenie is a revision aid, not an official AQA product and not a replacement for your teacher, textbook
            or the official specification. The AI marking is designed to give useful guidance and practice, but it can
            make mistakes — always check marks, grades and content against official AQA materials and your teacher's
            feedback. Treat estimated grades as a rough guide, not a prediction of your real result.
          </p>
        </section>
      </div>
    </div>
  );
}
